<template>
    <div>
        <FormInput type="text" v-model.trim="search" class="mt-1 inline-block" :placeholder="$t('messages.search')" />
        <div v-if="search.length > 1" class="mt-3">
            <div v-for="category in localCategories" :key="category.id" class="md:grid md:grid-cols-2 md:gap-6">
                <div
                    class="sm:col-span-1"
                    v-for="dimension in category.dimensions"
                    :key="dimension.id"
                    v-show="dimension.title.indexOf(search) !== -1"
                >
                    <label class="block text-sm font-medium leading-5 text-gray-700">
                        {{ dimension.abbreviation }} - {{ dimension.title }}
                    </label>
                    <FormInput
                        type="number"
                        v-model.number="dimension.value"
                        min="0"
                        step="1"
                        class="mt-1 inline-block"
                    />
                </div>
            </div>
        </div>

        <Tabs class="mt-5" v-else :default-index="categories.findIndex((c) => c.id === activity.category_id)">
            <Tab :title="category.name" v-for="category in localCategories" :key="category.id">
                {{ category.name }}

                <div class="md:grid md:grid-cols-2 md:gap-6">
                    <div class="sm:col-span-1" v-for="dimension in category.dimensions" :key="dimension.id">
                        <label class="block text-sm font-medium leading-5 text-gray-700">
                            {{ dimension.abbreviation }} - {{ dimension.title }}
                        </label>
                        <FormInput
                            type="number"
                            v-model.number="dimension.value"
                            min="0"
                            step="1"
                            class="mt-1 inline-block"
                        />
                    </div>
                </div>
            </Tab>
        </Tabs>

        <form :action="activity.links.update" method="post" @submit.prevent="submit" class="mt-5">
            <div class="flex justify-end">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="false" />
            </div>
        </form>
    </div>
</template>

<script>
import Tab from '@/components/Tab.vue';
import Tabs from '@/components/Tabs.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: { SubmitFormButton, Tab, Tabs, FormInput },
    name: 'ActivityDimensionsSelector',
    props: {
        categories: { required: true, type: Array },
        activity: { required: true, type: Object },
    },
    data() {
        return {
            search: '',
            localCategories: this.categories,
        };
    },
    methods: {
        submit() {
            this.$inertia.patch(this.activity.links.update, {
                dimensions: this.selectedDimensions,
            });
        },
    },
    computed: {
        selectedDimensions: function () {
            return this.localCategories
                .flatMap((c) => c.dimensions)
                .filter((c) => c.value)
                .map((c) => ({ id: c.id, value: c.value }));
        },
    },
};
</script>
